module.exports = __webpack_public_path__ + "static/img/xl2.13b9be3.png";


//////////////////
// WEBPACK FOOTER
// ./static/default/mobile_img/role3/control2/xl2.png
// module id = D5b5
// module chunks = 7